import LegalShell from "@/components/LegalShell";

export default function TermsOfUse() {
  return (
    <LegalShell
      title="Terms of Use"
      subtitle="The terms that apply to your use of this website."
      testId="terms-page"
    >
      <h2 className="text-navy font-serif text-2xl mt-2 mb-3">1. Acceptance</h2>
      <p>
        By using <span className="text-navy">www.salihigroup.com</span> (the &ldquo;Site&rdquo;) you agree to these Terms
        of Use. If you do not agree, please do not use the Site.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">2. Nature of content</h2>
      <p>
        The Site provides general information about Salihi Group and its subsidiaries. Nothing on the Site
        constitutes legal, financial, engineering, investment, or other professional advice. A formal
        engagement — with a signed agreement — is required before any advice is relied upon.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">3. Intellectual property</h2>
      <p>
        All content on the Site — including text, logos, marks, imagery, and layout — is owned by or licensed
        to Salihi Group and its subsidiaries. You may not reproduce, redistribute, or use the content for
        commercial purposes without prior written consent.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">4. Third-party marks and testimonials</h2>
      <p>
        Client logos and testimonials shown on the Site are the property of their respective owners and are
        used with permission for the purpose of identifying professional relationships.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">5. Links to third-party sites</h2>
      <p>
        The Site may link to third-party websites. Salihi Group does not control and is not responsible for
        the content, policies, or practices of those sites.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">6. Disclaimer</h2>
      <p>
        The Site is provided on an &ldquo;as is&rdquo; basis. Salihi Group makes no warranty as to the accuracy,
        completeness, or availability of the Site and disclaims all implied warranties to the maximum extent
        permitted by law.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">7. Limitation of liability</h2>
      <p>
        To the maximum extent permitted by law, Salihi Group shall not be liable for indirect, incidental, or
        consequential losses arising from your use of the Site.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">8. Changes</h2>
      <p>
        We may update these terms from time to time. The current version is always the one posted on this
        page.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">9. Governing law</h2>
      <p>
        These Terms are governed by the laws of the Federal Republic of Somalia. Any dispute shall be
        resolved by the courts of Somalia.
      </p>

      <h2 className="text-navy font-serif text-2xl mt-10 mb-3">Contact</h2>
      <p>
        <a className="text-gold hover:underline" href="mailto:info@salihigroup.com">info@salihigroup.com</a>
      </p>
    </LegalShell>
  );
}
